"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // Support server-side rendering.

var getGlobal = function getGlobal() {
  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  throw new Error('The tab-ads package should run in a browser or Node.');
};

var _default = getGlobal;
exports.default = _default;